module.exports = __webpack_public_path__ + "img/berts-logo.bf5d136a.png";